import { Component, inject } from '@angular/core';
import { SwStateMachineService } from '../services/sw-state-machine.service';
import { NzButtonComponent } from 'ng-zorro-antd/button';

@Component({
  selector: 'ava-smart-weather-error',
  standalone: true,
  template: `
    <button nz-button [nzType]="'primary'" (click)="swSms.sendEvent('RETRY')">Retry</button>
    <button nz-button [nzType]="'primary'" [style]="'margin-left: 20px'" (click)="swSms.sendEvent('RELOAD')">
      Cancel and Reload
    </button>
  `,
  imports: [NzButtonComponent],
})
export class ErrorComponent {
  swSms = inject(SwStateMachineService);
}
